/**
 * The form two identity values are compared in to decide whether they describe the same patient.
 *
 * Only formatting is removed: letter case, padding around each Person Name component, runs of
 * spaces inside a component, and trailing empty components. `DOE^JOHN  A`, `Doe^John A^^` and
 * `DOE ^JOHN A` therefore compare equal, while a difference in any letter does not. Values without
 * a `^` (sex, dates) reduce to trim, collapse and case fold.
 */
export function identityKey(value: string): string {
    return value
        .split('^')
        .map((component) => component.trim().replace(/\s+/g, ' '))
        .join('^')
        .replace(/\^+$/, '')
        .toUpperCase();
}
